export default "__VITE_ASSET__3iHZ6f0k__"